// Cómo se reparte lo que se recibe al cerrar un préstamo.
//
// ── El caso que lo destapó ──
//
// A Marco Meléndez se le prestó $2.000.000 al 10% mensual y a los CINCO DÍAS
// vino y pagó el capital más el mes completo: $2.200.000. Es lo pactado —el mes
// se cobra entero aunque se devuelva antes— y es de lo más común.
//
// El programa, a los cinco días, cree que el interés generado es CERO: cuenta
// por meses cumplidos. Así que su `deudaTotal` era $2.000.000, y el cierre
// hacía `Math.min(recibido, deudaTotal)`: los $200.000 de más **se perdían sin
// que nada lo dijera**, y encima los $2.000.000 entraban todos como capital. La
// ganancia de ese préstamo quedaba en cero en los informes.
//
// ── La regla ──
//
// Lo que se recibe DE MÁS sobre lo que el programa calculó es interés. No puede
// ser otra cosa: el capital es el capital, no crece. Y nunca se descarta plata
// que de verdad entró — si algo no cuadra, se anota y se explica, no se recorta.

const num = (x) => {
  const n = Number(x);
  return Number.isFinite(n) ? n : 0;
};

export function repartirCierre(recibido, estado) {
  const plata = num(recibido);
  if (plata < 0 || !estado) return null;

  const interesPendiente = Math.max(0, num(estado.interesPendiente));
  const capitalPendiente = Math.max(0, num(estado.capitalPendiente));
  const deuda = Math.max(0, num(estado.deudaTotal));

  if (plata > deuda) {
    // Pagó más de lo que el programa había calculado. La diferencia es interés
    // pactado que todavía no se había cumplido por calendario —el mes completo
    // devuelto a los cinco días—, y hay que registrarla como interés o la
    // ganancia de ese préstamo sale en cero.
    return {
      interes: Math.round(interesPendiente + (plata - deuda)),
      capital: Math.round(capitalPendiente),
      condonado: 0,
      deMas: Math.round(plata - deuda),
      recibido: Math.round(plata),
    };
  }

  // Pagó lo calculado o menos. El interés se cubre primero: es lo que conviene
  // a quien presta, porque el interés sin pagar sigue acumulándose.
  const interes = Math.min(plata, interesPendiente);
  return {
    interes: Math.round(interes),
    capital: Math.round(Math.max(0, plata - interes)),
    condonado: Math.round(deuda - plata),
    deMas: 0,
    recibido: Math.round(plata),
  };
}
